import { render, staticRenderFns } from "./ProductDetailDialog.vue?vue&type=template&id=4854e972&scoped=true"
import script from "./ProductDetailDialog.vue?vue&type=script&lang=js"
export * from "./ProductDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./ProductDetailDialog.vue?vue&type=style&index=0&id=4854e972&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4854e972",
  null
  
)

export default component.exports